export default {
  VIEW_HELP_VIDEO: 'Help_Video',
  TABLE_FILTERS: 'Table_Filters',
  TABLE_DATE_FILTERS: 'Table_Date_Filters',
  TABLE_ROW: 'Table_Row',
  CLEAR_FILTERS: 'Table_Clear_Filters',
  CHANGE_PAGE_LIMIT: 'Table_Number_Of_Pages',
  DOWNLOAD_REPORT: 'Report_Download',
  DOWNLOAD_SAMPLE: 'Sample_File_Download',

  BAV: {
    ALL: {
      VERIFY_SUCCESS: 'BAV_Successful',
      VERIFY_FAILED: 'BAV_Failed',
    },
    BATCH: {
      UPLOAD_SUCCESS: 'Batch_BAV_Successful',
      UPLOAD_PARTIAL_SUCCESS: 'Batch_BAV_Partially_Successful',
      UPLOAD_FAILURE: 'Batch_BAV_Failed',
    },
  },

  PAN: {
    ALL: {
      VERIFY_SUCCESS: 'PAN_Successful',
      VERIFY_FAILED: 'PAN_Failed',
    },
    BATCH: {
      UPLOAD_SUCCESS: 'Batch_PAN_Successful',
      UPLOAD_PARTIAL_SUCCESS: 'Batch_PAN_Partially_Successful',
      UPLOAD_FAILURE: 'Batch_PAN_Failed',
    },
  },

  PAN_Advance: {
    ALL: {
      VERIFY_SUCCESS: 'PAN_Advance_Successful',
      VERIFY_FAILED: 'PAN_Advance_Failed',
    },
    BATCH: {
      UPLOAD_SUCCESS: 'Batch_PAN_Advance_Successful',
      UPLOAD_PARTIAL_SUCCESS: 'Batch_PAN_Advance_Partially_Successful',
      UPLOAD_FAILURE: 'Batch_PAN_Advance_Failed',
    },
  },

  IFSC: {
    VERIFY_SUCCESS: 'IFSC_Successful',
    VERIFY_FAILED: 'IFSC_Failed',
  },

  UPI: {
    ALL: {
      VERIFY_SUCCESS: 'UPI_Successful',
      VERIFY_FAILED: 'UPI_Failed',
    },
    BATCH: {
      UPLOAD_SUCCESS: 'Batch_UPI_Successful',
      UPLOAD_PARTIAL_SUCCESS: 'Batch_UPI_Partially_Successful',
      UPLOAD_FAILURE: 'Batch_UPI_Failed',
    },
  },

  GSTIN: {
    VERIFY_SUCCESS: 'GSTIN_Successful',
    VERIFY_FAILED: 'GSTIN_Failed',
  },

  FORMS: {
    BATCH: {
      UPLOAD_SUCCESS: 'Batch_FORMS_Successful',
      UPLOAD_PARTIAL_SUCCESS: 'Batch_FORMS_Partially_Successful',
      UPLOAD_FAILURE: 'Batch_FORMS_Failed',
    },
  },
};
